module.exports = __webpack_public_path__ + "img/start-date-img.3d9b1297.svg";